function procedureForItem(item) {
  const procedure = item?.procedures;
  return Array.isArray(procedure) ? procedure[0] : procedure;
}

function itemRawMinutes(item) {
  const raw =
    item?.duration_minutes ??
    item?.raw_duration_minutes ??
    item?.suggested_duration_minutes ??
    procedureForItem(item)?.suggested_duration_minutes;
  const minutes = Number(raw);
  return Number.isFinite(minutes) && minutes > 0 ? minutes : 0;
}

function itemUsesChairSetup(item) {
  const flag = item?.uses_chair_setup ?? procedureForItem(item)?.uses_chair_setup;
  return flag !== false;
}

export function recallDurationBreakdown(items = [], chairSetupMinutes = 0) {
  const rawProcedureMinutes = (items || []).reduce(
    (sum, item) => sum + itemRawMinutes(item),
    0,
  );
  const usesChairSetup = rawProcedureMinutes > 0 && (items || []).some(itemUsesChairSetup);
  const setup = usesChairSetup ? Number(chairSetupMinutes) || 0 : 0;

  return {
    rawProcedureMinutes,
    chairSetupMinutes: setup,
    recommendedMinutes: rawProcedureMinutes + setup,
    usesChairSetup,
  };
}

export function recommendedRecallDurationMinutes(items = [], chairSetupMinutes = 0) {
  return recallDurationBreakdown(items, chairSetupMinutes).recommendedMinutes;
}
